import {
  FILTERS_SET_FAVORITE_ENTITY_TYPE_TYPE,
  FAVORITE_ENTITIES_GET_FAVORITE_ENTITIES_TYPE,
} from '../../constants/actionTypes';
import { EEntityType } from '../../types/filters';
import { TReduxActions } from '../../types/redux';
import { EGetFavoriteEntitiesStatus } from '../../types/results';

const defaultFavoriteEntityType: EEntityType | null = null;

export function favoriteEntityTypeReducer(
  state: EEntityType | null = defaultFavoriteEntityType,
  action: TReduxActions,
) {
  switch (action.type) {
    case FILTERS_SET_FAVORITE_ENTITY_TYPE_TYPE:
      return action.favoriteEntityType;

    case FAVORITE_ENTITIES_GET_FAVORITE_ENTITIES_TYPE:
      return action.status === EGetFavoriteEntitiesStatus.Failed ? action.prevFilters.favoriteEntityType : state;
  }

  return state;
}
